import APIClient from '../../services/APIClient';
import { filterPlaceHolder, makeApiCall } from '../../services/ApiService';

export default {

    getLogs: (params:any) => makeApiCall({
        startCallMessage:'API: Fetching Log Data',
        successMessage: 'API: Successfully Fetched Log Data',
        failureMessage: 'API: Fetching Log Failed',
        params,
        url:'/admin/logs',
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.logs,
    }),

    deleteLogs: (data: any) =>  makeApiCall({
        startCallMessage:'API: Deleting Log',
        successMessage: 'API: Deleting Log Success',
        failureMessage: 'API: Deleting Log Failed',
        data,
        url: '/admin/logs/delete',
        shouldShowNotifications: true,
        method: APIClient.post,
        config: null,
        extractPath: (data) => data,
    }),

    editLogs: (data: any) => {
        return makeApiCall({
        startCallMessage: 'API: Editing Log',
        successMessage: 'API: Editing Log Success',
        failureMessage: 'API: Editing Log Failed',
        data,
        shouldShowNotifications: true,
        url: '/admin/logs' + (data._id ? `/${data._id}` : ''),
        method: APIClient.put,
        config: null,
        extractPath: (data) => data,
    })}

}
